export const MESSENGER_EVENT_NAME = '__remote-messenger-event__'
export const MESSENGER_KEY = '__remote_messenger__'
export const KEYOF_GET_ID = '__get-webcontents-id__'
